const ControllingPage = () => {
    return (
        <div className="container mx-auto">
            <span className="text-sm">soon(tm)</span>
        </div>
    );
};

export default ControllingPage;
